(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.card-variant-picker').forEach(function (picker) {
      const card    = picker.closest('product-card, [data-product-card]');
      const priceEl = card ? card.querySelector('.product-price') : null;
      const pills   = picker.querySelectorAll('.variant-pill');

      function selectPill(pill) {
        if (pill.classList.contains('is-soldout')) return;

        pills.forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-selected', 'false');
        });

        pill.classList.add('is-selected');
        pill.setAttribute('aria-selected', 'true');

        if (priceEl && pill.dataset.price) {
          priceEl.classList.add('is-updating');
          setTimeout(function () {
            priceEl.textContent = pill.dataset.price;
            priceEl.classList.remove('is-updating');
          }, 150);
        }

        const img = card ? card.querySelector('img[data-variant-image], .product-card__image img') : null;
        if (img && pill.dataset.image) {
          img.src = pill.dataset.image;
        }
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          selectPill(pill);
        });

        pill.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectPill(pill);
          }
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            const all   = Array.from(pills).filter(p => !p.classList.contains('is-soldout'));
            const index = all.indexOf(pill);
            const next  = e.key === 'ArrowRight'
              ? all[(index + 1) % all.length]
              : all[(index - 1 + all.length) % all.length];
            if (next) { next.focus(); selectPill(next); }
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
